export default "__VITE_ASSET__PiaBz_S6__"